import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index';
import { saveChannelReferrer, checkAndReportChannel } from '../utils/channel-tracker';
import { reportChannelReferrer } from '../api/user';

import GlobalSettings from '../views/home/global-settings';
import Faq from '../views/home/faq';
import TigaNotice from '../components/tiga-notice';
import TigaNoticeList from '../views/home/tiga-notice-list';
import TigaNoticeDetail from '../views/home/tiga-notice-detail';
import TigaRates from '../views/home/tiga-rates';

import ExchangeHome from '../views/exchange/index';
import relatedPosts from '../views/exchange/related-posts/related-posts.vue';
// import Exchange from '../views/exchange/exchange';
// import TakeOrder from '../views/exchange/take-order/take-order';

import Post from '../views/post/post';
import postDetail from '../views/post/detail/ad-detail';
import CreatePost from '../views/post/create/create';
import SetLocation from '../views/post/create/create-settings/set-location';
import SetPrice from '../views/post/create/create-settings/set-price';
import SetPriceLimit from '../views/post/create/create-settings/set-price-limit';
import SetActivityTime from '../views/post/create/create-settings/set-activity-time';
import SetTrader from '../views/post/create/create-settings/set-trader';

import Mine from '../views/mine/mine';
import Kyc from '../views/mine/new/kyc';
import KycAdv from '../views/mine/new/kyc-adv';
import KycVideo from '../views/mine/new/kyc-video';
import KycVideoKatoon from '../views/mine/new/kyc-video-katoon';
import messageHelper from '../views/mine/new/message-helper.vue';

import Notice from '../views/mine/notice/notice';
import AddNotice from '../views/mine/notice/add';
import ApplyCertification from '../views/mine/apply-certification/apply-certification';
import ApplyInternational from '../views/mine/apply-certification/apply-international';
import ApplyGreen from '../views/mine/new/apply-green';
import Todamoon from '../views/mine/new/todamoon';
import NoticeSetPrice from '../views/mine/notice/set-price';
import Login from '../views/login/login';
import LoginWS from '../views/login/login-ws';
import Orders from '../views/mine/orders/orders';
import OrderDetail from '../views/mine/orders/order-detail';
import OrderEvaluate from '../views/mine/orders/order-evaluate';
import OrderTimeChange from '../views/mine/orders/order-time-change';
import OrderResult from '../views/result/result'; //order_result
import payInfo from '../views/mine/pay-info/pay-info';
import payInfoList from '../views/mine/pay-info/pay-info-list';
import payInfoAdd from '../views/mine/pay-info/pay-info-add';
import payInfoDetail from '../views/mine/pay-info/pay-info-detail';
import payInfoSelect from '../views/mine/pay-info/pay-info-select';
import userManage from '../views/mine/user-manage/user-manage.vue';
import userManageWhiteList from '../views/mine/user-manage/user-whitelist.vue';
import userManageBlackList from '../views/mine/user-manage/user-blacklist.vue';
import communityHelper from '../views/mine/community-helper/community-helper.vue';
import communityHelperEditSymbol from '../views/mine/community-helper/edit-symbol';
import commission from '../views/mine/commission/commission';
import commissionRank from '../views/mine/commission/commission-rank.vue';
import orderStatistics from '../views/mine/statistics/statistics.vue';
import orderStatisticsSetTime from '../views/mine/statistics/statistics-set-time.vue';
import InviteCode from '../views/mine/invite-code/invite-code.vue';
import InviteRules from '../views/mine/commission/commission-rules.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/exchange',
  },
  {
    path: '/globalSettings',
    component: GlobalSettings,
    name: 'globalSetting',
  },
  {
    path: '/faq',
    component: Faq,
    name: 'faq',
  },
  {
    path: '/tigaNotice',
    component: TigaNotice,
    name: 'tigaNotice',
  },
  {
    path: '/tigaNotice/list',
    component: TigaNoticeList,
    name: 'tigaNoticeList',
  },
  {
    path: '/tigaNotice/detail',
    component: TigaNoticeDetail,
    name: 'tigaNoticeDetail',
  },
  {
    path: '/tigaRates',
    component: TigaRates,
    name: 'tigaRates',
  },
  {
    path: '/exchange',
    component: ExchangeHome,
    name: 'index',
  },
  {
    path: '/post',
    component: Post,
  },
  {
    path: '/mine',
    component: Mine,
  },
  {
    path: '/exchange/takeOrder',
    component: ExchangeHome,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/exchange/related',
    component: relatedPosts,
    name: 'related',
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/post/create',
    component: CreatePost,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/post/detail',
    component: postDetail,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/post/edit',
    component: CreatePost,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/post/create/setLocation',
    component: SetLocation,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/post/create/setPrice',
    component: SetPrice,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/post/create/setPriceLimit',
    component: SetPriceLimit,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/post/create/setActivityTime',
    component: SetActivityTime,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/post/create/SetTrader',
    component: SetTrader,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/orders',
    component: Orders,
    meta: {
      requireLogin: true,
      keepAlive: true,
    },
  },
  {
    path: '/mine/orders/orderDetail',
    component: OrderDetail,
    name: 'orderDetail',
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/orders/orderTimeChange',
    component: OrderTimeChange,
    name: 'orderTimeChange',
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/applyCertification',
    component: ApplyCertification,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/kyc',
    component: Kyc,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/kycAdv',
    component: KycAdv,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/kycVideo',
    component: KycVideo,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/kycVideoKatoon',
    component: KycVideoKatoon,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/applyGreen',
    component: ApplyGreen,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/todamoon',
    component: Todamoon,
    meta: {
      requireLogin: false,
    },
  },
  {
    path: '/mine/applyInternational',
    component: ApplyInternational,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/inviteCode',
    component: InviteCode,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/payInfo',
    component: payInfo,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/payInfo/list',
    component: payInfoList,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/payInfo/list/add',
    component: payInfoAdd,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/payInfo/list/detail',
    component: payInfoDetail,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/payInfo/select',
    component: payInfoSelect,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/orderEvaluation',
    component: OrderEvaluate,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/orderResult',
    component: OrderResult,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/login-ws',
    component: LoginWS,
  },
  {
    path: '/mine/notice',
    component: Notice,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/notice/add',
    component: AddNotice,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/notice/setPrice',
    component: NoticeSetPrice,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/userManage',
    component: userManage,
  },
  {
    path: '/mine/userManage/whitelist',
    component: userManageWhiteList,
  },
  {
    path: '/mine/userManage/blacklist',
    component: userManageBlackList,
  },
  {
    path: '/mine/communityHelper',
    component: communityHelper,
    meta: {
      requireLogin: true,
      requireOwner: true,
    },
  },
  {
    path: '/mine/messageHelper',
    component: messageHelper,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/communityHelper/editSymbol',
    component: communityHelperEditSymbol,
    meta: {
      requireLogin: true,
      requireOwner: true,
    },
  },
  {
    path: '/mine/commission',
    component: commission,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/commission/rank',
    component: commissionRank,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/commission/rules',
    component: InviteRules,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/statistics',
    component: orderStatistics,
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/mine/statistics/setTime',
    component: orderStatisticsSetTime,
    meta: {
      requireLogin: true,
    },
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from) {
    return new Promise(resolve => {
      if (to.matched[0] && to.matched[0] === from.matched[0]) {
        // 同级之间切换时，视口置顶不需要等待
        resolve({ x: 0, y: 0 });
      } else {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 300);
      }
    });
  },
});

router.beforeEach((to, from, next) => {
  // 捕获渠道参数（支持 channel、referrer 等参数名）
  // 1. 先从 Vue Router 的 query 中获取（hash 后的参数）
  let channelId = to.query.channel || to.query.referrer;
  
  // 2. 如果没有，尝试从原始 URL 中解析（hash 前的参数）
  if (!channelId) {
    const urlParams = new URLSearchParams(window.location.search);
    channelId = urlParams.get('channel') || urlParams.get('referrer');
  }
  
  // 3. 如果有渠道参数，保存
  if (channelId) {
    saveChannelReferrer(channelId);
  } else {
    // 4. 如果没有渠道参数，且 localStorage 中也没有保存过，则保存默认值（自然流量）
    const existingChannel = window.localStorage.getItem('channel_referrer');
    if (!existingChannel) {
      saveChannelReferrer('partner_me');
    }
  }

  if (to.matched.length === 0) {
    return next({ name: 'index' });
  }
  if (
    !store.state.isLogin &&
    to.matched.some(record => record.meta.requireLogin)
  ) {
    window.localStorage.setItem('loginFrom', to.fullPath);
    return next({
      path: '/login',
    });
  }
  if (
    to.matched.some(record => record.meta && record.meta.requireOwner) &&
    !store.state.userInfo.isOwner
  ) {
    return next({
      name: 'index',
    });
  }
  next();
});

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(() => {});
};

VueRouter.prototype.replace = function(location) {
  return originalReplace.call(this, location).catch(() => {});
};

// 在路由跳转后检查是否需要上报渠道信息
router.afterEach(() => {
  // 检查条件：用户已登录 && channelReferrer 为空
  if (store.state.isLogin && store.state.userInfo.channelReferrer === null) {
    // 延迟执行，确保 userInfo 已经加载完成
    setTimeout(() => {
      // 再次检查，确保后端返回的 channelReferrer 仍然为 null
      if (store.state.isLogin && store.state.userInfo.channelReferrer === null) {
        // 检查 localStorage 是否有渠道信息
        const existingChannel = window.localStorage.getItem('channel_referrer');
        if (!existingChannel) {
          // 如果没有，保存默认值（自然流量）
          saveChannelReferrer('partner_me');
        }
        
        checkAndReportChannel(reportChannelReferrer)
          .then((channelId) => {
            if (channelId) {
              // 上报成功后，更新 userInfo 中的 channelReferrer
              store.commit('setUserInfo', { channelReferrer: channelId });
            }
          })
          .catch(() => {
            // 忽略错误
          });
      }
    }, 500);
  }
});


export default router;
